/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { withTranslation } from "react-i18next";
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import { Button, ThemeProvider, Modal } from '@workboard/wobo-ui';
import axios from 'axios';
import { kpiMarketplaceConstants } from './../../constants/kpiMarketplace.constants';
import WorkdayConfigModal from './myNewIntegrations-workday.component';

class MyNewIntegrationsComponent extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      iframeHeight: '1350px',
      userIntegrations: [],
      openLearnMoreModal: false,
      openDuplicateIdentityModal: false,
      openWorkdayConfigModal: false,
      selectedIntegration: {},
      modalSubmitOnly: false,
      modalSubmitLabel: 'Enable',
    };
    this.handleMessage = this.handleMessage.bind(this);
    this.getUserAccessToken = this.getUserAccessToken.bind(this);
  }

  async componentDidMount () {
    if (document.querySelector('.integrationIframeWrapper')) {
      document.querySelector('.integrationIframeWrapper').style.display = 'block';
    }

    window.addEventListener('message', this.handleMessage);

    const userIntegrationsResponse = await axios.get('/wb/integration/getUserIntegrations');

    const cookieValue = this.findCookieValue(kpiMarketplaceConstants.DUPLICATE_INTEGRATION_IDENTITY_FOUND_COOKIE);
    if (cookieValue) {
      const id = parseInt(cookieValue);
      const name = kpiMarketplaceConstants.WOBO_EXT_APP_KPI_TYPE_MAP.get(id) ?? '';
      const icon = kpiMarketplaceConstants.WOBO_EXT_APP_LOGO_MAP.get(id) ?? '';
      const content = kpiMarketplaceConstants.WOBO_EXT_APP_DUPLICATE_INTEGRATION_FOUND_MAP.get(name) ?? '';
      const displayName = kpiMarketplaceConstants.WOBO_EXT_APP_DISPLAY_NAME_MAP.get(id) ?? '';
      this.showDuplicateIdentityModal({ id, name, icon, content, displayName });
    }

    const userIntegrated = userIntegrationsResponse.data?.integrations.map((item) => {
      item.displayName = item.name;
      if (kpiMarketplaceConstants.WOBO_EXT_APP_DISPLAY_NAME_MAP.has(item.id)) {
        item.displayName = kpiMarketplaceConstants.WOBO_EXT_APP_DISPLAY_NAME_MAP.get(item.id);
      }
      if (kpiMarketplaceConstants.WOBO_EXT_APP_DESCRIPTION_MAP.has(item.id)) {
        item.description = kpiMarketplaceConstants.WOBO_EXT_APP_DESCRIPTION_MAP.get(item.id);
      }
      if (kpiMarketplaceConstants.WOBO_EXT_APP_LOGO_MAP.has(item.id)) {
        item.icon = kpiMarketplaceConstants.WOBO_EXT_APP_LOGO_MAP.get(item.id);
      }
      return item;
    });
    userIntegrated.sort(
      (a, b) => b.isIntegrated - a.isIntegrated || a?.displayName?.localeCompare(b?.displayName),
    );

    // uses authorizeHRISIntegrationAdmin() logic uses `hrisIntegrationAdmin` property
    const showWorkdayHRIS = userIntegrationsResponse.data?.integrations.find((app) => app.name === 'workday')?.userIsHrisAdmin;

    const integrationGroups = [
      {
        name: 'Communication',
        items: userIntegrated.filter((app) => ['ms_graph', 'slack', 'cisco_webex'].includes(app.name) && this.checkFeatureFlag(app.name)),
      },
      {
        name: 'Calendar',
        items: userIntegrated.filter((app) => ['google', 'outlook'].includes(app.name) && this.checkFeatureFlag(app.name)),
      },
    ];
    if (showWorkdayHRIS) {
      integrationGroups.push({
        name: 'HRIS',
        items: userIntegrated.filter((app) => ['workday'].includes(app.name) && showWorkdayHRIS),
      });
    }
    this.setState({ userIntegrations: integrationGroups });
  }

  componentWillUnmount () {
    window.removeEventListener('message', this.handleMessage);
  }

  handleMessage (event) {
    const frame = document.getElementById('wobo-integration-external-app-container');
    let externalSource;
    const { integrations } = this.props;
    const { func, args } = event.data;
    switch (func) {
      case 'initialize':
        this.getUserAccessToken(args?.child.clientId).then((woboToken) => {
          frame.contentWindow.postMessage(
            woboClients.createMessage(func, { woboToken, integrationsFeatureFlag: integrations }),
            event.origin
          );
        });
        break;
      case 'enabled-integration':
        externalSource = args.child.externalSource;
        this.triggerEnableIntegration(externalSource.name);
        break;
      case 'disabled-integration':
        externalSource = args.child.externalSource;
        this.triggerDisableIntegration(externalSource.woboAppId, args.child.externalInstance);
        break;
      case 'iframe-resize-integration':
        this.setState({ iframeHeight: args.child.iframeSize.height });
        break;
      default:
        console.log('Unknown event: %o', event);
    }
  }

  getExternalAppButtonClass (name) {
    const appToClassMap = kpiMarketplaceConstants.LEGACY_CLASSNAMES_MAP;
    return appToClassMap.has(name) ? appToClassMap.get(name) : null;
  }

  async getUserAccessToken (clientId) {
    const res = await axios.get(`${wbConfig.baseUrl}/client/generateUserAccessToken?client_id=${clientId}`);
    return res?.data;
  }

  checkFeatureFlag (appName) {
    let flagKey;
    switch (appName) {
      case 'ms_graph':
        flagKey = 'msteam';
        break;
      case 'google':
        flagKey = 'googleCalendar';
        break;
      default:
        flagKey = appName;
    }
    const { integrations } = this.props;
    return integrations[flagKey] && integrations[flagKey]?.visibility;
  }

  findCookieValue (cookie) {
    const cookieName = `${cookie}=`;
    const allCookies = document.cookie;
    const allCookiesArr = allCookies.split('; ');
    const filteredCookies = allCookiesArr.filter((c) => c.indexOf(cookieName) === 0);
    if (filteredCookies.length === 0) {
      return false;
    }

    const cookieValue = filteredCookies[0].substring(cookieName.length);
    const decodeValue = decodeURIComponent(cookieValue);

    return decodeValue.substring(decodeValue.indexOf('"')).split('"')[1];
  }

  clearCookie (cookie) {
    document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    this.setState({
      openDuplicateIdentityModal: false,
    });
  }

  isOtherCalendarItemIntegrated (group, item) {
    if (!group || !group.items || group.name !== 'Calendar') {
      return false;
    }

    const name = item.name === 'google' ? 'outlook' : 'google';
    const otherItem = group.items.find((gItem) => gItem.name === name);
    return otherItem?.isIntegrated;
  }

  triggerEnableIntegration (woboAppName) {
    const buttonClass = this.getExternalAppButtonClass(woboAppName);
    if (woboAppName === 'ms_graph') {
      axios.get('/wb/integration/sendEvent?source=ms_teams&location=integrations_page&activity=Enable&activity_type=Click');
    }
    if (!buttonClass) {
      return;
    }
    if ($(buttonClass)[0] !== undefined) {
      $(buttonClass)[0].click();
    }

    if ($(buttonClass)[0] === undefined && woboAppName === 'jira') {
      $('.jira-oauth2-click').trigger('click');
    }

    if ($(buttonClass)[0] === undefined && woboAppName === 'workday') {
      this.setState({ openWorkdayConfigModal: true, selectedIntegration: { id: 36, name: 'workday' } });
    }
  }

  triggerDisableIntegration (woboAppId, instance) {
    let selector;
    if (woboAppId === 5) {
      selector = `.disableIntegration[data-app-id="${woboAppId}"][data-instance-url="${instance.belong_to}"]`;
    } else {
      selector = `.disableIntegration[data-app-id="${woboAppId}"]`;
    }

    if (selector && $(selector)) {
      if (woboAppId === 9) {
        axios.get('/wb/integration/sendEvent?source=ms_teams&location=integrations_page&activity=Disable&activity_type=Click');
      }
      $(selector).trigger('click');
    }
  }

  showLearnMoreModal (group, item) {
    if (!kpiMarketplaceConstants.WOBO_EXT_APP_LEARNMORE_CONTENT_MAP.has(item.name)) {
      return;
    }

    if (item.id === 9) {
      axios.get('/wb/integration/sendEvent?source=ms_teams&location=integrations_page&activity=LearnMore&activity_type=Click');
    }
    const modalContent = kpiMarketplaceConstants.WOBO_EXT_APP_LEARNMORE_CONTENT_MAP.get(item.name);

    this.setState({ selectedGroup: group, selectedIntegration: item }, () => {
      const { selectedGroup, selectedIntegration } = this.state;

      let submitLabel = '';
      if (selectedIntegration && selectedIntegration.isIntegrated) {
        submitLabel = 'Disable';
      } else if (selectedGroup.name === 'Calendar') {
        submitLabel = (this.isOtherCalendarItemIntegrated(selectedGroup, selectedIntegration)) ? 'Close' : 'Enable';
      } else if (['workday'].includes(selectedIntegration.name)) {
        submitLabel = 'Configure';
      } else {
        submitLabel = 'Enable';
      }

      this.setState({
        openLearnMoreModal: true,
        modalSubmitLabel: submitLabel,
        modalSubmitOnly: selectedGroup.name === 'Calendar' && this.isOtherCalendarItemIntegrated(group, item),
        modalContent,
      });
    });
  }

  showDuplicateIdentityModal (item) {
    this.setState({
      duplicateIntegrationDetail: item,
      openDuplicateIdentityModal: true,
    });
  }

  render () {
    const integrationGroupRender = (
      <div className="wobo-external-app-container-wrapper">
        {this.state.userIntegrations
          && this.state.userIntegrations.map((group) => (
            <div key={group.name} className="wobo-external-app-group">
              <h3 className="wobo-user-integration-group-header">{group.name}</h3>
              <div className="d-flex flex-row flex-gap">
                {group.items.map((item, index) => (
                  <div className="d-flex flex-column kpis-cardshape" key={item.name + index} data-testid={`${item.name}card`}>
                    <div className="d-flex flex-row flex-fill">
                      <div aria-hidden="true" className={`${item.icon} d-flex flex align-items-right wobo-image-logo`} style={{ height: "auto" }} />
                      <div className="flex kpis-headers">
                        <h4 className="short-div kpis-heading">{item.displayName || item.name}</h4>
                        <b className="short-div kpis-sub-heading">{group.name}</b>
                      </div>
                      <div className="flex flex-fill" />
                      {item?.isIntegrated === true && <div className="wobo-checkmark-icon-filled" />}
                      {item?.isConfigured === true && <div className="wobo-checkmark-icon-filled" />}
                    </div>
                    {item.integrationData && item.integrationData.integrated_by && (
                      <div className="d-flex flex-row flex-fill wobo-user-connection">
                        Logged in with {item.integrationData.integrated_by}
                      </div>
                    )}
                    <div className="d-flex flex-row flex-fill">
                      <p className="kpis-content">{item.description}</p>
                    </div>
                    <div className="d-flex flex-row align-items-end flex-fill">
                      <div className="flex-fill" />
                      <div className="flex flex-row align-items-start">
                        <Button variant="link" onClick={() => this.showLearnMoreModal(group, item)}>
                          Learn More
                        </Button>
                      </div>
                      <div className="d-flex wobo-integration-actions">
                        {typeof item.isIntegrated !== 'undefined' && item.isIntegrated === false && (
                          <div>
                            {group.name !== 'Calendar' && (
                              <Button variant="secondary" size="medium" onClick={() => this.triggerEnableIntegration(item.name)}>
                                { ['workday'].includes(item.name) ? 'Configure' : 'Enable'}
                              </Button>
                            )}

                            {group.name === 'Calendar' && !this.isOtherCalendarItemIntegrated(group, item) && (
                              <Button variant="secondary" size="medium" onClick={() => this.triggerEnableIntegration(item.name)}>
                                Enable
                              </Button>
                            )}

                            {group.name === 'Calendar' && this.isOtherCalendarItemIntegrated(group, item) && (
                              <Button variant="tertiary" size="medium" disabled title="Only one calendar integration can be enabled at a time.">
                                Enable
                              </Button>
                            )}
                          </div>
                        )}

                        {typeof item.isIntegrated !== 'undefined' && item.isIntegrated === true && (
                          <Button variant="tertiary" size="medium" onClick={() => this.triggerDisableIntegration(item.id)}>
                            Disable
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
    );

    return (
      <ThemeProvider>
        <div className="wobo-external-app-container-wrapper" style={{ width: '100%', height: this.state.iframeHeight }}>
          <h1 style={{ margin: '0px' }}>Integrations</h1>
          <hr className="wobo-line-separator" />
          {integrationGroupRender}
          <iframe title="wobo-integration-external-app-container" id="wobo-integration-external-app-container" name="wobo-external-app-container-name" src={`${wbConfig.kpiUrl}/client/user-integrations`} style={{ width: 'inherit', height: 'inherit', minHeight: '100vh' }} />
        </div>
        <Modal
          isOpen={this.state.openDuplicateIdentityModal}
          className="wobo-user-integration-modal"
          onDismiss={() => {
            this.clearCookie('duplicateIntegrationIdentityFound');
          }}
          onSubmit={() => {
            this.clearCookie('duplicateIntegrationIdentityFound');
          }}
        >
          <div className="wobo-user-integration-modal-inner" style={{ width: '600px' }}>
            <div className="d-flex flex-row flex-fill align-items-center">
              <div className={`${this.state.duplicateIntegrationDetail?.icon} d-flex flex align-items-right wobo-image-logo`} />
              <div className="flex kpis-headers">
                <h1 className="short-div kpis-heading">{this.state.duplicateIntegrationDetail?.displayName}</h1>
              </div>
            </div>
            <div className="kpis-content" dangerouslySetInnerHTML={{ __html: this.state.duplicateIntegrationDetail?.content }} />
          </div>
        </Modal>
        <Modal
          title="Learn More"
          isOpen={this.state.openLearnMoreModal}
          onDismiss={() => this.setState({ openLearnMoreModal: false })}
          onSubmit={() => {
            this.setState({ openLearnMoreModal: false });
            if (this.state.selectedIntegration.isIntegrated) {
              this.triggerDisableIntegration(this.state.selectedIntegration?.id);
            } else if (!this.state.modalSubmitOnly) {
              this.triggerEnableIntegration(this.state.selectedIntegration?.name);
            }
          }}
          dismissLabel="Close"
          submitOnly={this.state.modalSubmitOnly}
          submitLabel={this.state.modalSubmitLabel}
          className="wobo-user-integration-modal"
          data-testid="wobo-user-integration-modal-test-id"
        >
          <div className="wobo-user-integration-modal-inner" style={{ width: '600px' }}>
            <div className="d-flex flex-row flex-fill align-items-center">
              <div className={`${this.state.selectedIntegration?.icon} d-flex flex align-items-right wobo-image-logo`} style={{height: "auto"}} />
              <div className="flex kpis-headers">
                <h1 className="short-div kpis-heading">{this.state.selectedIntegration?.displayName}</h1>
                <b className="short-div">{this.state.selectedGroup?.name}</b>
              </div>
            </div>
            {this.state.modalSubmitOnly && (
              <div className="wobo-user-integration-alert">
                <ErrorOutline />
                <span className="message">
                  Only one calendar can be integrated at a time. Disable your current calendar integration before enabling another calendar integration.
                </span>
              </div>
            )}
            <div className="kpis-content" dangerouslySetInnerHTML={{ __html: this.state.modalContent }} />
          </div>
        </Modal>
        {this.state.openWorkdayConfigModal && (
          <WorkdayConfigModal
            isOpen={this.state.openWorkdayConfigModal}
            onDismiss={() => this.setState({ openWorkdayConfigModal: false })}
            selectedIntegration={this.state.selectedIntegration}
          />
        )}
      </ThemeProvider>
    );
  }
}

export default withTranslation()(MyNewIntegrationsComponent);
